import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceOptions extends Layout {
    labelLowCost: Label;
    panelIntellirouteDistanceOptions: Panel;
    panelIntellirouteLowCost: Panel;
    panelMMDistanceOptions: Panel;
    panelMMGuide19Options: Panel;
    panelMMGuide20Options: Panel;
    panelPCMilerDistanceOptions: Panel;
    sourceDistanceProfileControl: DataSource;
    switchCustomRoads: Switch;
    switchFiftyThreeTrailer: Switch;
    switchIntellirouteAppRoadwk: Switch;
    switchIntellirouteCanBorder: Switch;
    switchIntellirouteHazmatRouting: Switch;
    switchIntelliroutePhysicalRestrictions: Switch;
    switchIntellirouteRteDelays: Switch;
    switchIntellirouteTrailerWidth: Switch;
    switchMM20Ferries: Switch;
    switchMM20Highways: Switch;
    switchMM20Tunnels: Switch;
    switchMM20UTurns: Switch;
    switchMM20UnpavedRoads: Switch;
    switchMMBorderCrossing: Switch;
    switchMMTolls: Switch;
    switchNationalNetwork: Switch;
    switchOverrideRestrictions: Switch;
    switchPCMilerBordersOpen: Switch;
    switchPCMilerHazmatRouting: Switch;
    switchPCMilerHighwayOnly: Switch;
    switchPCMilerTollsDiscourages: Switch;
    switchSIntelliroute53ftTrailer: Switch;
    switchUseLocalOverride: Switch;
    textboxLookupType: Textbox;
    textboxMMVersion: Textbox;
    textboxMethod: Textbox;
    textboxMmDepartOption: Textbox;
    textboxMmDepartureTime: Textbox;
    textboxMmG19TrailerOption: Textbox;
    textboxMmG19VehicleType: Textbox;
    textboxMmG20TrailerOption: Textbox;
    textboxMmG20VehicleType: Textbox;
    textboxMmGovernorSpeed: Textbox;
    textboxMmHazmatTypes: Textbox;
    textboxMmHeightFt: Textbox;
    textboxMmHeightIn: Textbox;
    textboxMmVehicleAxleCount: Textbox;
    textboxMmVehicleWeight: Textbox;
    textboxMmWidthFt: Textbox;
    textboxMmWidthIn: Textbox;
    textboxPCMilerVersion: Textbox;
    textboxProfileDescription: Textbox;
    textboxProfileId: Textbox;
    textboxRmAvgFuelCost: Textbox;
    textboxRmAvgFuelEff: Textbox;
    textboxRmCostPerHour: Textbox;
    textboxRmMaintCost: Textbox;
    textboxRmSegOverride: Textbox;
    textboxRmTollBias: Textbox;
    textboxRmTollOverride: Textbox;
    textboxRmTruckType: Textbox;
    textboxVendor: Textbox;
}
